import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link,  useHistory, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import api from "../../services/api";
import ReCAPTCHA from "react-google-recaptcha";

const ForgetResetScreen = ({location}) => {
  let history = useHistory();
  const { token } = useParams();
 
  const [show, setShow] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const redirect = location.search ? location.search.split("=")[1] : "/";
  

  const handleClick = () => {
    history.push("/forgot-admin-password");
  };

  const resetHandler = async (e) => {
    try {
      if (password !== confirmPassword) {
        toast.error("Senhas não conferem");
      } else {

        const config = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        // eslint-disable-next-line
        const { data } = await api.put(
          "/api/usersCRC/forget-admin-reset",
          { token: token, password: password },
          config
        );
        
        document.location.href = "/adminlogin";  

      }
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      toast.error(err);
    }
  };

  const tokenHandler = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    // eslint-disable-next-line
    const { data } = await api.post(
      "/api/usersCRC/forget-admin-reset",
      { token: token },
      config
    );
  
    return data;

  };

  function onChange(value) {
    if (value === null) {
      setIsVerified(false);
    } else {
      setIsVerified(true);
    }
  }

  useEffect(() => {
    // eslint-disable-next-line
    
    if (token) {
      tokenHandler()
        .then((tkemail) => {
          const now = new Date();
          const dataAtual = now.toLocaleString().substring(20, 0);
          const expire = new Date(Date.parse(tkemail.passwordResetExpire))
            .toLocaleString()
            .substring(20, 0);

          if (expire > dataAtual) {
            setShow(true);
            toast.success("Token válido!");
          } else {
            setShow(false);
            toast.error(
              `O token expirou, digite novamente o email cadastrado para recuperar acesso.`
            );
            setTimeout(function () {
              handleClick();
            }, 6500);
          }
        })
        .catch((error) => {
          setShow(false);
          toast.error(`Token invalid!`);
          setTimeout(function () {
            handleClick();
          }, 6500);
        });
    }

    // eslint-disable-next-line
  }, []);

  return (
    <>
      {show ? (
        <>
          <ToastContainer />
          <div className="container">
            <div className="card o-hidden border-0 shadow-lg my-5">
              <div className="card-body ">
                <div className="row ">
                  <div className="col-lg-5 d-none d-lg-block bg-password-image "></div>
                  <div className="col-lg-7">
                    <div className="p-5">
                      <div className="text-center">
                        <h1 className="h4 text-gray-900 mb-4">
                        CV SESC ALAGOAS ADMINISTRAÇÃO / Recuperar Acesso - Esqueci a Senha!
                        </h1>
                      </div>
                      {/* formulario de cadastro  */}
                      <form className="user" onSubmit={resetHandler}>
                        <div className="form-group">
                          <input
                            type="password"
                            className="form-control form-control-user"
                            placeholder="Entre com senha"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                        </div>

                        <div className="form-group">
                          <input
                            type="password"
                            className="form-control form-control-user"
                            placeholder="Repita a senha"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                          />
                        </div>

                        <Button
                          type="submit"
                          className="btn btn-warning btn-user btn-block"
                          disabled={!isVerified}
                        >
                          Recuperar conta
                        </Button>
                      </form>

                      <hr />

                      <div className=" form-group text-center mt-4 ml-5">
                        <ReCAPTCHA
                          sitekey={process.env.REACT_APP_RECAPTCHA}
                          onChange={onChange}
                        />
                      </div>

                      <div className="text-center mt-5">
                        <Link
                          to={
                            redirect ? `/adminlogin?redirect=${redirect}` : "/adminlogin"
                          }
                          className="small"
                        >
                          Você já possui conta? Login!
                        </Link>
                      </div>

                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <ToastContainer />
        </>
      )}
    </>
  );
};

export default ForgetResetScreen;
